import cx from 'clsx';

import { MembershipStandardNudgeTooltip } from '~/domains/plusMembership/components/Tooltips/MembershipStandardNudgeTooltip';

import type { ProductPriceProps } from '.';

import {
  MembershipStandard16x8Icon,
  MembershipStandard24x12Icon,
} from '~/assets/icons';

export default function MembershipStandardNudgeProductPrice({
  totalDiscountedPrice,
  price,
  className,
  nudgeTotalDiscountedPrice,
  is3x2 = false,
}: ProductPriceProps) {
  return (
    <div className={cx('relative', className)}>
      <div
        className="mb-4"
        style={
          is3x2
            ? { fontSize: 14, fontWeight: 700, lineHeight: '18px' }
            : { fontSize: 16, fontWeight: 700, lineHeight: '20px' }
        }
      >
        {(totalDiscountedPrice || price).toLocaleString()}원
      </div>
      <div className="flex items-center gap-x-4">
        {is3x2 ? (
          <MembershipStandard16x8Icon />
        ) : (
          <MembershipStandard24x12Icon />
        )}
        <span
          className={cx(
            'text-error',
            is3x2 ? 'typo-footnote200-semibold' : 'typo-footnote300-semibold',
          )}
        >
          멤버십쿠폰가
        </span>
        <MembershipStandardNudgeTooltip />
      </div>
      <p
        className="text-danger-regular"
        style={
          is3x2
            ? { fontSize: 14, fontWeight: 700, lineHeight: '18px' }
            : { fontSize: 16, fontWeight: 700, lineHeight: '20px' }
        }
      >
        {nudgeTotalDiscountedPrice?.toLocaleString()}원
      </p>
    </div>
  );
}
